import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import SecureIcon from 'src/Assets/Svg/common/secure.svg?react'
import VideoCameraIcon from 'src/Assets/Svg/common/video-camera.svg?react'
import IncreaseIcon from 'src/Assets/Svg/common/increase.svg?react'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.brandGreen};
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  width: 100%;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    box-shadow: none;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  width: 100%;
`

const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

const CardHeadline = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100%;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.darkGrey};
`

const CardTitle = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const CardDescription = styled.p`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  margin: 0;
`

const EXPECTATION_CARDS = [
  {
    icon: SecureIcon,
    title: 'Budget protection',
    description:
      'You only pay for videos that meet our standards. If a video is Rejected, the funds are instantly credited back to your balance for a replacement. No risk, no wasted budget.',
  },
  {
    icon: VideoCameraIcon,
    title: 'Authenticity over polish',
    description:
      'We focus on UGC (User-Generated Content). These raw, organic videos feel "native" to TikTok, which consistently drives higher engagement and views than polished, expensive productions.',
  },
  {
    icon: IncreaseIcon,
    title: 'The 30-day growth cycle',
    description:
      'The goal is total Views. Since creators need time to produce and post, the first few days may be quiet. We track performance 24/7 to ensure you hit your target by the end of the month.',
  },
]

export const ExpectationCards: FC = () => (
  <Container>
    <Title>What you should know</Title>
    <CardsList>
      {EXPECTATION_CARDS.map(({ icon: Icon, title, description }) => (
        <Card key={title}>
          <CardHeadline>
            <IconWrapper>
              <Icon />
            </IconWrapper>
            <CardTitle>{title}</CardTitle>
          </CardHeadline>
          <CardDescription>{description}</CardDescription>
        </Card>
      ))}
    </CardsList>
  </Container>
)
